import responsiveToggle from './components/responsive-toggle'
import headerSticky from "./components/header-sticky";
import skipLinks from './components/skip-links';
import tables from './components/tables';
import dialogs from './components/dialogs';
import tabs from './components/tablist';
import headerCrisisBar from './components/header-crisis-bar';
import externalLink from './components/external-link';
import search from "./components/search";
import deepl from "./components/deepl";
import navigationInline from "./components/navigation-inline";
import tableOfContents from "./components/table-of-contents";
import sliders from "./components/sliders";
import openingTimes from "./components/opening-times";
import highContrast from "./components/high-contrast";

highContrast();
tableOfContents();
sliders();
openingTimes();
navigationInline();
deepl();
search();
headerCrisisBar( document.querySelector( '.crisis-bar' ) );
tabs( document.querySelectorAll( '.tabs' ) );
responsiveToggle( document.querySelector( '.responsive-toggle' ) )
headerSticky()
skipLinks( document.getElementById( 'skip-to-content' ) );
tables( document.querySelectorAll( 'table:not([class])' ) );
externalLink();
dialogs( document.querySelectorAll( '[data-open-dialog]' ), document.querySelectorAll( '[data-close-dialog]' ), document.querySelectorAll( '[data-dialog]' ) );
// Configuration for ReadSpeaker
window.rsConf = {general: {usePost: true}};
